import { render, staticRenderFns } from "./sepa.vue?vue&type=template&id=84e47c14&"
import script from "./sepa.vue?vue&type=script&lang=js&"
export * from "./sepa.vue?vue&type=script&lang=js&"
import style0 from "./sepa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports